export const counties: Partial<Record<string, string[]>> = {
  AK: [
    'ALEUTIANS EAST BOROUGH',
    'ALEUTIANS WEST CENSUS AREA',
    'ANCHORAGE MUNICIPALITY',
    'BETHEL CENSUS AREA',
    'BRISTOL BAY BOROUGH',
    'DENALI BOROUGH',
    'DILLINGHAM CENSUS AREA',
    'FAIRBANKS NORTH STAR BOROUGH',
    'HAINES BOROUGH',
    'HOONAH-ANGOON',
    'JUNEAU CITY AND BOROUGH',
    'KENAI PENINSULA BOROUGH',
    'KETCHIKAN GATEWAY BOROUGH',
    'KODIAK ISLAND BOROUGH',
    'LAKE AND PENINSULA BOROUGH',
    'MATANUSKA-SUSITNA BOROUGH',
    'NOME CENSUS AREA',
    'NORTH SLOPE BOROUGH',
    'NORTHWEST ARCTIC BOROUGH',
    'PETERSBURG',
    'PRINCE OF WALES-HYDER CENSUS AREA',
    'PRINCE OF WALES-KETCHIKAN',
    'SITKA CITY AND BOROUGH',
    'SKAGWAY',
    'SOUTHEAST FAIRBANKS CENSUS AREA',
    'VALDEZ-CORDOVA CENSUS AREA',
    'WADE HAMPTON CENSUS AREA',
    'WRANGELL',
    'YAKUTAT CITY AND BOROUGH',
    'YUKON-KOYUKUK CENSUS AREA',
  ],
  AL: [
    'AUTAUGA',
    'BALDWIN',
    'BARBOUR',
    'BIBB',
    'BLOUNT',
    'BULLOCK',
    'BUTLER',
    'CALHOUN',
    'CHAMBERS',
    'CHEROKEE',
    'CHILTON',
    'CHOCTAW',
    'CLARKE',
    'CLAY',
    'CLEBURNE',
    'COFFEE',
    'COLBERT',
    'CONECUH',
    'COOSA',
    'COVINGTON',
    'CRENSHAW',
    'CULLMAN',
    'DALE',
    'DALLAS',
    'DEKALB',
    'ELMORE',
    'ESCAMBIA',
    'ETOWAH',
    'FAYETTE',
    'FRANKLIN',
    'GENEVA',
    'GREENE',
    'HALE',
    'HENRY',
    'HOUSTON',
    'JACKSON',
    'JEFFERSON',
    'LAMAR',
    'LAUDERDALE',
    'LAWRENCE',
    'LEE',
    'LIMESTONE',
    'LOWNDES',
    'MACON',
    'MADISON',
    'MARENGO',
    'MARION',
    'MARSHALL',
    'MOBILE',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'PERRY',
    'PICKENS',
    'PIKE',
    'RANDOLPH',
    'RUSSELL',
    'SHELBY',
    'ST. CLAIR',
    'SUMTER',
    'TALLADEGA',
    'TALLAPOOSA',
    'TUSCALOOSA',
    'WALKER',
    'WASHINGTON',
    'WILCOX',
    'WINSTON',
  ],
  AR: [
    'ARKANSAS',
    'ASHLEY',
    'BAXTER',
    'BENTON',
    'BOONE',
    'BRADLEY',
    'CALHOUN',
    'CARROLL',
    'CHICOT',
    'CLARK',
    'CLAY',
    'CLEBURNE',
    'CLEVELAND',
    'COLUMBIA',
    'CONWAY',
    'CRAIGHEAD',
    'CRAWFORD',
    'CRITTENDEN',
    'CROSS',
    'DALLAS',
    'DESHA',
    'DREW',
    'FAULKNER',
    'FRANKLIN',
    'FULTON',
    'GARLAND',
    'GRANT',
    'GREENE',
    'HEMPSTEAD',
    'HOT SPRING',
    'HOWARD',
    'INDEPENDENCE',
    'IZARD',
    'JACKSON',
    'JEFFERSON',
    'JOHNSON',
    'LAFAYETTE',
    'LAWRENCE',
    'LEE',
    'LINCOLN',
    'LITTLE RIVER',
    'LOGAN',
    'LONOKE',
    'MADISON',
    'MARION',
    'MILLER',
    'MISSISSIPPI',
    'MONROE',
    'MONTGOMERY',
    'NEVADA',
    'NEWTON',
    'OUACHITA',
    'PERRY',
    'PHILLIPS',
    'PIKE',
    'POINSETT',
    'POLK',
    'POPE',
    'PRAIRIE',
    'PULASKI',
    'RANDOLPH',
    'SALINE',
    'SCOTT',
    'SEARCY',
    'SEBASTIAN',
    'SEVIER',
    'SHARP',
    'ST FRANCIS',
    'STONE',
    'UNION',
    'VAN BUREN',
    'WASHINGTON',
    'WHITE',
    'WOODRUFF',
    'YELL',
  ],
  AS: ['AMERICAN SAMOA', 'EASTERN', 'MANUA', 'ROSE ISLAND', 'SWAINS ISLAND', 'WESTERN'],
  AZ: [
    'APACHE',
    'COCHISE',
    'COCONINO',
    'GILA',
    'GRAHAM',
    'GREENLEE',
    'LA PAZ',
    'MARICOPA',
    'MOHAVE',
    'NAVAJO',
    'PIMA',
    'PINAL',
    'SANTA CRUZ',
    'YAVAPAI',
    'YUMA',
  ],
  CA: [
    'ALAMEDA',
    'ALPINE',
    'AMADOR',
    'BUTTE',
    'CALAVERAS',
    'COLUSA',
    'CONTRA COSTA',
    'DEL NORTE',
    'EL DORADO',
    'FRESNO',
    'GLENN',
    'HUMBOLDT',
    'IMPERIAL',
    'INYO',
    'KERN',
    'KINGS',
    'LAKE',
    'LASSEN',
    'LOS ANGELES',
    'MADERA',
    'MARIN',
    'MARIPOSA',
    'MENDOCINO',
    'MERCED',
    'MODOC',
    'MONO',
    'MONTEREY',
    'NAPA',
    'NEVADA',
    'ORANGE',
    'PLACER',
    'PLUMAS',
    'RIVERSIDE',
    'SACRAMENTO',
    'SAN BENITO',
    'SAN BERNARDINO',
    'SAN DIEGO',
    'SAN FRANCISCO',
    'SAN JOAQUIN',
    'SAN LUIS OBISPO',
    'SAN MATEO',
    'SANTA BARBARA',
    'SANTA CLARA',
    'SANTA CRUZ',
    'SHASTA',
    'SIERRA',
    'SISKIYOU',
    'SOLANO',
    'SONOMA',
    'STANISLAUS',
    'SUTTER',
    'TEHAMA',
    'TRINITY',
    'TULARE',
    'TUOLUMNE',
    'VENTURA',
    'YOLO',
    'YUBA',
  ],
  CO: [
    'ADAMS',
    'ALAMOSA',
    'ARAPAHOE',
    'ARCHULETA',
    'BACA',
    'BENT',
    'BOULDER',
    'BROOMFIELD',
    'CHAFFEE',
    'CHEYENNE',
    'CLEAR CREEK',
    'CONEJOS',
    'COSTILLA',
    'CROWLEY',
    'CUSTER',
    'DELTA',
    'DENVER',
    'DOLORES',
    'DOUGLAS',
    'EAGLE',
    'ELBERT',
    'EL PASO',
    'FREMONT',
    'GARFIELD',
    'GILPIN',
    'GRAND',
    'GUNNISON',
    'HINSDALE',
    'HUERFANO',
    'JACKSON',
    'JEFFERSON',
    'KIOWA',
    'KIT CARSON',
    'LAKE',
    'LA PLATA',
    'LARIMER',
    'LAS ANIMAS',
    'LINCOLN',
    'LOGAN',
    'MESA',
    'MINERAL',
    'MOFFAT',
    'MONTEZUMA',
    'MONTROSE',
    'MORGAN',
    'OTERO',
    'OURAY',
    'PARK',
    'PHILLIPS',
    'PITKIN',
    'PROWERS',
    'PUEBLO',
    'RIO BLANCO',
    'RIO GRANDE',
    'ROUTT',
    'SAGUACHE',
    'SAN JUAN',
    'SAN MIGUEL',
    'SEDGWICK',
    'SUMMIT',
    'TELLER',
    'WASHINGTON',
    'WELD',
    'YUMA',
  ],
  CT: ['FAIRFIELD', 'HARTFORD', 'LITCHFIELD', 'MIDDLESEX', 'NEW HAVEN', 'NEW LONDON', 'TOLLAND', 'WINDHAM'],
  DC: ['DISTRICT OF COLUMBIA'],
  DE: ['KENT', 'NEW CASTLE', 'SUSSEX'],
  FL: [
    'ALACHUA',
    'BAKER',
    'BAY',
    'BRADFORD',
    'BREVARD',
    'BROWARD',
    'CALHOUN',
    'CHARLOTTE',
    'CITRUS',
    'CLAY',
    'COLLIER',
    'COLUMBIA',
    'DESOTO',
    'DIXIE',
    'DUVAL',
    'ESCAMBIA',
    'FLAGLER',
    'FRANKLIN',
    'GADSDEN',
    'GILCHRIST',
    'GLADES',
    'GULF',
    'HAMILTON',
    'HARDEE',
    'HENDRY',
    'HERNANDO',
    'HIGHLANDS',
    'HILLSBOROUGH',
    'HOLMES',
    'INDIAN RIVER',
    'JACKSON',
    'JEFFERSON',
    'LAFAYETTE',
    'LAKE',
    'LEE',
    'LEON',
    'LEVY',
    'LIBERTY',
    'MADISON',
    'MANATEE',
    'MARION',
    'MARTIN',
    'MIAMI-DADE',
    'MONROE',
    'NASSAU',
    'OKALOOSA',
    'OKEECHOBEE',
    'ORANGE',
    'OSCEOLA',
    'PALM BEACH',
    'PASCO',
    'PINELLAS',
    'POLK',
    'PUTNAM',
    'SANTA ROSA',
    'SARASOTA',
    'SEMINOLE',
    'ST JOHNS',
    'ST LUCIE',
    'SUMTER',
    'SUWANNEE',
    'TAYLOR',
    'UNION',
    'VOLUSIA',
    'WAKULLA',
    'WALTON',
    'WASHINGTON',
  ],
  GA: [
    'APPLING',
    'ATKINSON',
    'BACON',
    'BAKER',
    'BALDWIN',
    'BANKS',
    'BARROW',
    'BARTOW',
    'BEN HILL',
    'BERRIEN',
    'BIBB',
    'BLECKLEY',
    'BRANTLEY',
    'BROOKS',
    'BRYAN',
    'BULLOCH',
    'BURKE',
    'BUTTS',
    'CALHOUN',
    'CAMDEN',
    'CANDLER',
    'CARROLL',
    'CATOOSA',
    'CHARLTON',
    'CHATHAM',
    'CHATTAHOOCHEE',
    'CHATTOOGA',
    'CHEROKEE',
    'CLARKE',
    'CLAY',
    'CLAYTON',
    'CLINCH',
    'COBB',
    'COFFEE',
    'COLQUITT',
    'COLUMBIA',
    'COOK',
    'COWETA',
    'CRAWFORD',
    'CRISP',
    'DADE',
    'DAWSON',
    'DECATUR',
    'DEKALB',
    'DODGE',
    'DOOLY',
    'DOUGHERTY',
    'DOUGLAS',
    'EARLY',
    'ECHOLS',
    'EFFINGHAM',
    'ELBERT',
    'EMANUEL',
    'EVANS',
    'FANNIN',
    'FAYETTE',
    'FLOYD',
    'FORSYTH',
    'FRANKLIN',
    'FULTON',
    'GILMER',
    'GLASCOCK',
    'GLYNN',
    'GORDON',
    'GRADY',
    'GREENE',
    'GWINNETT',
    'HABERSHAM',
    'HALL',
    'HANCOCK',
    'HARALSON',
    'HARRIS',
    'HART',
    'HEARD',
    'HENRY',
    'HOUSTON',
    'IRWIN',
    'JACKSON',
    'JASPER',
    'JEFF DAVIS',
    'JEFFERSON',
    'JENKINS',
    'JOHNSON',
    'JONES',
    'LAMAR',
    'LANIER',
    'LAURENS',
    'LEE',
    'LIBERTY',
    'LINCOLN',
    'LONG',
    'LOWNDES',
    'LUMPKIN',
    'MACON',
    'MADISON',
    'MARION',
    'MCDUFFIE',
    'MCINTOSH',
    'MERIWETHER',
    'MILLER',
    'MITCHELL',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'MURRAY',
    'MUSCOGEE',
    'NEWTON',
    'OCONEE',
    'OGLETHORPE',
    'PAULDING',
    'PEACH',
    'PICKENS',
    'PIERCE',
    'PIKE',
    'POLK',
    'PULASKI',
    'PUTNAM',
    'QUITMAN',
    'RABUN',
    'RANDOLPH',
    'RICHMOND',
    'ROCKDALE',
    'SCHLEY',
    'SCREVEN',
    'SEMINOLE',
    'SPALDING',
    'STEPHENS',
    'STEWART',
    'SUMTER',
    'TALBOT',
    'TALIAFERRO',
    'TATTNALL',
    'TAYLOR',
    'TELFAIR',
    'TERRELL',
    'THOMAS',
    'TIFT',
    'TOOMBS',
    'TOWNS',
    'TREUTLEN',
    'TROUP',
    'TURNER',
    'TWIGGS',
    'UNION',
    'UPSON',
    'WALKER',
    'WALTON',
    'WARE',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WHEELER',
    'WHITE',
    'WHITFIELD',
    'WILCOX',
    'WILKES',
    'WILKINSON',
    'WORTH',
  ],
  GU: ['GUAM'],
  HI: ['HAWAII', 'HONOLULU', 'KALAWAO', 'KAUAI', 'MAUI'],
  IA: [
    'ADAIR',
    'ADAMS',
    'ALLAMAKEE',
    'APPANOOSE',
    'AUDUBON',
    'BENTON',
    'BLACK HAWK',
    'BOONE',
    'BREMER',
    'BUCHANAN',
    'BUENA VISTA',
    'BUTLER',
    'CALHOUN',
    'CARROLL',
    'CASS',
    'CEDAR',
    'CERRO GORDO',
    'CHEROKEE',
    'CHICKASAW',
    'CLARKE',
    'CLAY',
    'CLAYTON',
    'CLINTON',
    'CRAWFORD',
    'DALLAS',
    'DAVIS',
    'DECATUR',
    'DELAWARE',
    'DES MOINES',
    'DICKINSON',
    'DUBUQUE',
    'EMMET',
    'FAYETTE',
    'FLOYD',
    'FRANKLIN',
    'FREMONT',
    'GREENE',
    'GRUNDY',
    'GUTHRIE',
    'HAMILTON',
    'HANCOCK',
    'HARDIN',
    'HARRISON',
    'HENRY',
    'HOWARD',
    'HUMBOLDT',
    'IDA',
    'IOWA',
    'JACKSON',
    'JASPER',
    'JEFFERSON',
    'JOHNSON',
    'JONES',
    'KEOKUK',
    'KOSSUTH',
    'LEE',
    'LINN',
    'LOUISA',
    'LUCAS',
    'LYON',
    'MADISON',
    'MAHASKA',
    'MARION',
    'MARSHALL',
    'MILLS',
    'MITCHELL',
    'MONONA',
    'MONROE',
    'MONTGOMERY',
    'MUSCATINE',
    "O'BRIEN",
    'OSCEOLA',
    'PAGE',
    'PALO ALTO',
    'PLYMOUTH',
    'POCAHONTAS',
    'POLK',
    'POTTAWATTAMIE',
    'POWESHIEK',
    'RINGGOLD',
    'SAC',
    'SCOTT',
    'SHELBY',
    'SIOUX',
    'STORY',
    'TAMA',
    'TAYLOR',
    'UNION',
    'VAN BUREN',
    'WAPELLO',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WINNEBAGO',
    'WINNESHIEK',
    'WOODBURY',
    'WORTH',
    'WRIGHT',
  ],
  ID: [
    'ADA',
    'ADAMS',
    'BANNOCK',
    'BEAR LAKE',
    'BENEWAH',
    'BINGHAM',
    'BLAINE',
    'BOISE',
    'BONNER',
    'BONNEVILLE',
    'BOUNDARY',
    'BUTTE',
    'CAMAS',
    'CANYON',
    'CARIBOU',
    'CASSIA',
    'CLARK',
    'CLEARWATER',
    'CUSTER',
    'ELMORE',
    'FRANKLIN',
    'FREMONT',
    'GEM',
    'GOODING',
    'IDAHO',
    'JEFFERSON',
    'JEROME',
    'KOOTENAI',
    'LATAH',
    'LEMHI',
    'LEWIS',
    'LINCOLN',
    'MADISON',
    'MINIDOKA',
    'NEZ PERCE',
    'ONEIDA',
    'OWYHEE',
    'PAYETTE',
    'POWER',
    'SHOSHONE',
    'TETON',
    'TWIN FALLS',
    'VALLEY',
    'WASHINGTON',
  ],
  IL: [
    'ADAMS',
    'ALEXANDER',
    'BOND',
    'BOONE',
    'BROWN',
    'BUREAU',
    'CALHOUN',
    'CARROLL',
    'CASS',
    'CHAMPAIGN',
    'CHRISTIAN',
    'CLARK',
    'CLAY',
    'CLINTON',
    'COLES',
    'COOK',
    'CRAWFORD',
    'CUMBERLAND',
    'DEKALB',
    'DE WITT',
    'DOUGLAS',
    'DUPAGE',
    'EDGAR',
    'EDWARDS',
    'EFFINGHAM',
    'FAYETTE',
    'FORD',
    'FRANKLIN',
    'FULTON',
    'GALLATIN',
    'GREENE',
    'GRUNDY',
    'HAMILTON',
    'HANCOCK',
    'HARDIN',
    'HENDERSON',
    'HENRY',
    'IROQUOIS',
    'JACKSON',
    'JASPER',
    'JEFFERSON',
    'JERSEY',
    'JO DAVIESS',
    'JOHNSON',
    'KANE',
    'KANKAKEE',
    'KENDALL',
    'KNOX',
    'LAKE',
    'LASALLE',
    'LAWRENCE',
    'LEE',
    'LIVINGSTON',
    'LOGAN',
    'MACON',
    'MACOUPIN',
    'MADISON',
    'MARION',
    'MARSHALL',
    'MASON',
    'MASSAC',
    'MCDONOUGH',
    'MCHENRY',
    'MCLEAN',
    'MENARD',
    'MERCER',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'MOULTRIE',
    'OGLE',
    'PEORIA',
    'PERRY',
    'PIATT',
    'PIKE',
    'POPE',
    'PULASKI',
    'PUTNAM',
    'RANDOLPH',
    'RICHLAND',
    'ROCK ISLAND',
    'SALINE',
    'SANGAMON',
    'SCHUYLER',
    'SCOTT',
    'SHELBY',
    'STARK',
    'ST. CLAIR',
    'STEPHENSON',
    'TAZEWELL',
    'UNION',
    'VERMILION',
    'WABASH',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WHITE',
    'WHITESIDE',
    'WILL',
    'WILLIAMSON',
    'WINNEBAGO',
    'WOODFORD',
  ],
  IN: [
    'ADAMS',
    'ALLEN',
    'BARTHOLOMEW',
    'BENTON',
    'BLACKFORD',
    'BOONE',
    'BROWN',
    'CARROLL',
    'CASS',
    'CLARK',
    'CLAY',
    'CLINTON',
    'CRAWFORD',
    'DAVIESS',
    'DEARBORN',
    'DECATUR',
    'DEKALB',
    'DELAWARE',
    'DUBOIS',
    'ELKHART',
    'FAYETTE',
    'FLOYD',
    'FOUNTAIN',
    'FRANKLIN',
    'FULTON',
    'GIBSON',
    'GRANT',
    'GREENE',
    'HAMILTON',
    'HANCOCK',
    'HARRISON',
    'HENDRICKS',
    'HENRY',
    'HOWARD',
    'HUNTINGTON',
    'JACKSON',
    'JASPER',
    'JAY',
    'JEFFERSON',
    'JENNINGS',
    'JOHNSON',
    'KNOX',
    'KOSCIUSKO',
    'LAGRANGE',
    'LAKE',
    'LAPORTE',
    'LAWRENCE',
    'MADISON',
    'MARION',
    'MARSHALL',
    'MARTIN',
    'MIAMI',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'NEWTON',
    'NOBLE',
    'OHIO',
    'ORANGE',
    'OWEN',
    'PARKE',
    'PERRY',
    'PIKE',
    'PORTER',
    'POSEY',
    'PULASKI',
    'PUTNAM',
    'RANDOLPH',
    'RIPLEY',
    'RUSH',
    'SCOTT',
    'SHELBY',
    'SPENCER',
    'STARKE',
    'STEUBEN',
    'ST JOSEPH',
    'SULLIVAN',
    'SWITZERLAND',
    'TIPPECANOE',
    'TIPTON',
    'UNION',
    'VANDERBURGH',
    'VERMILLION',
    'VIGO',
    'WABASH',
    'WARREN',
    'WARRICK',
    'WASHINGTON',
    'WAYNE',
    'WELLS',
    'WHITE',
    'WHITLEY',
  ],
  KS: [
    'ALLEN',
    'ANDERSON',
    'ATCHISON',
    'BARBER',
    'BARTON',
    'BOURBON',
    'BROWN',
    'BUTLER',
    'CHASE',
    'CHAUTAUQUA',
    'CHEROKEE',
    'CHEYENNE',
    'CLARK',
    'CLAY',
    'CLOUD',
    'COFFEY',
    'COMANCHE',
    'COWLEY',
    'CRAWFORD',
    'DECATUR',
    'DICKINSON',
    'DONIPHAN',
    'DOUGLAS',
    'EDWARDS',
    'ELK',
    'ELLIS',
    'ELLSWORTH',
    'FINNEY',
    'FORD',
    'FRANKLIN',
    'GEARY',
    'GOVE',
    'GRAHAM',
    'GRANT',
    'GRAY',
    'GREELEY',
    'GREENWOOD',
    'HAMILTON',
    'HARPER',
    'HARVEY',
    'HASKELL',
    'HODGEMAN',
    'JACKSON',
    'JEFFERSON',
    'JEWELL',
    'JOHNSON',
    'KEARNY',
    'KINGMAN',
    'KIOWA',
    'LABETTE',
    'LANE',
    'LEAVENWORTH',
    'LINCOLN',
    'LINN',
    'LOGAN',
    'LYON',
    'MARION',
    'MARSHALL',
    'MCPHERSON',
    'MEADE',
    'MIAMI',
    'MITCHELL',
    'MONTGOMERY',
    'MORRIS',
    'MORTON',
    'NEMAHA',
    'NEOSHO',
    'NESS',
    'NORTON',
    'OSAGE',
    'OSBORNE',
    'OTTAWA',
    'PAWNEE',
    'PHILLIPS',
    'POTTAWATOMIE',
    'PRATT',
    'RAWLINS',
    'RENO',
    'REPUBLIC',
    'RICE',
    'RILEY',
    'ROOKS',
    'RUSH',
    'RUSSELL',
    'SALINE',
    'SCOTT',
    'SEDGWICK',
    'SEWARD',
    'SHAWNEE',
    'SHERIDAN',
    'SHERMAN',
    'SMITH',
    'STAFFORD',
    'STANTON',
    'STEVENS',
    'SUMNER',
    'THOMAS',
    'TREGO',
    'WABAUNSEE',
    'WALLACE',
    'WASHINGTON',
    'WICHITA',
    'WILSON',
    'WOODSON',
    'WYANDOTTE',
  ],
  KY: [
    'ADAIR',
    'ALLEN',
    'ANDERSON',
    'BALLARD',
    'BARREN',
    'BATH',
    'BELL',
    'BOONE',
    'BOURBON',
    'BOYD',
    'BOYLE',
    'BRACKEN',
    'BREATHITT',
    'BRECKINRIDGE',
    'BULLITT',
    'BUTLER',
    'CALDWELL',
    'CALLOWAY',
    'CAMPBELL',
    'CARLISLE',
    'CARROLL',
    'CARTER',
    'CASEY',
    'CHRISTIAN',
    'CLARK',
    'CLAY',
    'CLINTON',
    'CRITTENDEN',
    'CUMBERLAND',
    'DAVIESS',
    'EDMONSON',
    'ELLIOTT',
    'ESTILL',
    'FAYETTE',
    'FLEMING',
    'FLOYD',
    'FRANKLIN',
    'FULTON',
    'GALLATIN',
    'GARRARD',
    'GRANT',
    'GRAVES',
    'GRAYSON',
    'GREEN',
    'GREENUP',
    'HANCOCK',
    'HARDIN',
    'HARLAN',
    'HARRISON',
    'HART',
    'HENDERSON',
    'HENRY',
    'HICKMAN',
    'HOPKINS',
    'JACKSON',
    'JEFFERSON',
    'JESSAMINE',
    'JOHNSON',
    'KENTON',
    'KNOTT',
    'KNOX',
    'LARUE',
    'LAUREL',
    'LAWRENCE',
    'LEE',
    'LESLIE',
    'LETCHER',
    'LEWIS',
    'LINCOLN',
    'LIVINGSTON',
    'LOGAN',
    'LYON',
    'MADISON',
    'MAGOFFIN',
    'MARION',
    'MARSHALL',
    'MARTIN',
    'MASON',
    'MCCRACKEN',
    'MCCREARY',
    'MCLEAN',
    'MEADE',
    'MENIFEE',
    'MERCER',
    'METCALFE',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'MUHLENBERG',
    'NELSON',
    'NICHOLAS',
    'OHIO',
    'OLDHAM',
    'OWEN',
    'OWSLEY',
    'PENDLETON',
    'PERRY',
    'PIKE',
    'POWELL',
    'PULASKI',
    'ROBERTSON',
    'ROCKCASTLE',
    'ROWAN',
    'RUSSELL',
    'SCOTT',
    'SHELBY',
    'SIMPSON',
    'SPENCER',
    'TAYLOR',
    'TODD',
    'TRIGG',
    'TRIMBLE',
    'UNION',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WHITLEY',
    'WOLFE',
    'WOODFORD',
  ],
  LA: [
    'ACADIA PARISH',
    'ALLEN PARISH',
    'ASCENSION PARISH',
    'ASSUMPTION PARISH',
    'AVOYELLES PARISH',
    'BEAUREGARD PARISH',
    'BIENVILLE PARISH',
    'BOSSIER PARISH',
    'CADDO PARISH',
    'CALCASIEU PARISH',
    'CALDWELL PARISH',
    'CAMERON PARISH',
    'CATAHOULA PARISH',
    'CLAIBORNE PARISH',
    'CONCORDIA PARISH',
    'DE SOTO PARISH',
    'EAST BATON ROUGE PARISH',
    'EAST CARROLL PARISH',
    'EAST FELICIANA PARISH',
    'EVANGELINE PARISH',
    'FRANKLIN PARISH',
    'GRANT PARISH',
    'IBERIA PARISH',
    'IBERVILLE PARISH',
    'JACKSON PARISH',
    'JEFFERSON DAVIS PARISH',
    'JEFFERSON PARISH',
    'LAFAYETTE PARISH',
    'LAFOURCHE PARISH',
    'LA SALLE PARISH',
    'LINCOLN PARISH',
    'LIVINGSTON PARISH',
    'MADISON PARISH',
    'MOREHOUSE PARISH',
    'NATCHITOCHES PARISH',
    'ORLEANS PARISH',
    'OUACHITA PARISH',
    'PLAQUEMINES PARISH',
    'POINTE COUPEE PARISH',
    'RAPIDES PARISH',
    'RED RIVER PARISH',
    'RICHLAND PARISH',
    'SABINE PARISH',
    'ST. BERNARD PARISH',
    'ST. CHARLES PARISH',
    'ST. HELENA PARISH',
    'ST. JAMES PARISH',
    'ST. JOHN THE BAPTIST PARISH',
    'ST. LANDRY PARISH',
    'ST. MARTIN PARISH',
    'ST. MARY PARISH',
    'ST. TAMMANY PARISH',
    'TANGIPAHOA PARISH',
    'TENSAS PARISH',
    'TERREBONNE PARISH',
    'UNION PARISH',
    'VERMILION PARISH',
    'VERNON PARISH',
    'WASHINGTON PARISH',
    'WEBSTER PARISH',
    'WEST BATON ROUGE PARISH',
    'WEST CARROLL PARISH',
    'WEST FELICIANA PARISH',
    'WINN PARISH',
  ],
  MA: [
    'BARNSTABLE',
    'BERKSHIRE',
    'BRISTOL',
    'DUKES',
    'ESSEX',
    'FRANKLIN',
    'HAMPDEN',
    'HAMPSHIRE',
    'MIDDLESEX',
    'NANTUCKET',
    'NORFOLK',
    'PLYMOUTH',
    'SUFFOLK',
    'WORCESTER',
  ],
  MD: [
    'ALLEGANY',
    'ANNE ARUNDEL',
    'BALTIMORE',
    'BALTIMORE (CITY)',
    'CALVERT',
    'CAROLINE',
    'CARROLL',
    'CECIL',
    'CHARLES',
    'DORCHESTER',
    'FREDERICK',
    'GARRETT',
    'HARFORD',
    'HOWARD',
    'KENT',
    'MONTGOMERY',
    "PRINCE GEORGE'S",
    "QUEEN ANNE'S",
    'SOMERSET',
    "ST. MARY'S",
    'TALBOT',
    'WASHINGTON',
    'WICOMICO',
    'WORCESTER',
  ],
  ME: [
    'ANDROSCOGGIN',
    'AROOSTOOK',
    'CUMBERLAND',
    'FRANKLIN',
    'HANCOCK',
    'KENNEBEC',
    'KNOX',
    'LINCOLN',
    'OXFORD',
    'PENOBSCOT',
    'PISCATAQUIS',
    'SAGADAHOC',
    'SOMERSET',
    'WALDO',
    'WASHINGTON',
    'YORK',
  ],
  MI: [
    'ALCONA',
    'ALGER',
    'ALLEGAN',
    'ALPENA',
    'ANTRIM',
    'ARENAC',
    'BARAGA',
    'BARRY',
    'BAY',
    'BENZIE',
    'BERRIEN',
    'BRANCH',
    'CALHOUN',
    'CASS',
    'CHARLEVOIX',
    'CHEBOYGAN',
    'CHIPPEWA',
    'CLARE',
    'CLINTON',
    'CRAWFORD',
    'DELTA',
    'DICKINSON',
    'EATON',
    'EMMET',
    'GENESEE',
    'GLADWIN',
    'GOGEBIC',
    'GRAND TRAVERSE',
    'GRATIOT',
    'HILLSDALE',
    'HOUGHTON',
    'HURON',
    'INGHAM',
    'IONIA',
    'IOSCO',
    'IRON',
    'ISABELLA',
    'JACKSON',
    'KALAMAZOO',
    'KALKASKA',
    'KENT',
    'KEWEENAW',
    'LAKE',
    'LAPEER',
    'LEELANAU',
    'LENAWEE',
    'LIVINGSTON',
    'LUCE',
    'MACKINAC',
    'MACOMB',
    'MANISTEE',
    'MARQUETTE',
    'MASON',
    'MECOSTA',
    'MENOMINEE',
    'MIDLAND',
    'MISSAUKEE',
    'MONROE',
    'MONTCALM',
    'MONTMORENCY',
    'MUSKEGON',
    'NEWAYGO',
    'OAKLAND',
    'OCEANA',
    'OGEMAW',
    'ONTONAGON',
    'OSCEOLA',
    'OSCODA',
    'OTSEGO',
    'OTTAWA',
    'PRESQUE ISLE',
    'ROSCOMMON',
    'SAGINAW',
    'SANILAC',
    'SCHOOLCRAFT',
    'SHIAWASSEE',
    'ST. CLAIR',
    'ST JOSEPH',
    'TUSCOLA',
    'VAN BUREN',
    'WASHTENAW',
    'WAYNE',
    'WEXFORD',
  ],
  MN: [
    'AITKIN',
    'ANOKA',
    'BECKER',
    'BELTRAMI',
    'BENTON',
    'BIG STONE',
    'BLUE EARTH',
    'BROWN',
    'CARLTON',
    'CARVER',
    'CASS',
    'CHIPPEWA',
    'CHISAGO',
    'CLAY',
    'CLEARWATER',
    'COOK',
    'COTTONWOOD',
    'CROW WING',
    'DAKOTA',
    'DODGE',
    'DOUGLAS',
    'FARIBAULT',
    'FILLMORE',
    'FREEBORN',
    'GOODHUE',
    'GRANT',
    'HENNEPIN',
    'HOUSTON',
    'HUBBARD',
    'ISANTI',
    'ITASCA',
    'JACKSON',
    'KANABEC',
    'KANDIYOHI',
    'KITTSON',
    'KOOCHICHING',
    'LAC QUI PARLE',
    'LAKE',
    'LAKE OF THE WOODS',
    'LE SUEUR',
    'LINCOLN',
    'LYON',
    'MAHNOMEN',
    'MARSHALL',
    'MARTIN',
    'MCLEOD',
    'MEEKER',
    'MILLE LACS',
    'MORRISON',
    'MOWER',
    'MURRAY',
    'NICOLLET',
    'NOBLES',
    'NORMAN',
    'OLMSTED',
    'OTTER TAIL',
    'PENNINGTON',
    'PINE',
    'PIPESTONE',
    'POLK',
    'POPE',
    'RAMSEY',
    'RED LAKE',
    'REDWOOD',
    'RENVILLE',
    'RICE',
    'ROCK',
    'ROSEAU',
    'SCOTT',
    'SHERBURNE',
    'SIBLEY',
    'STEARNS',
    'STEELE',
    'STEVENS',
    'ST LOUIS',
    'SWIFT',
    'TODD',
    'TRAVERSE',
    'WABASHA',
    'WADENA',
    'WASECA',
    'WASHINGTON',
    'WATONWAN',
    'WILKIN',
    'WINONA',
    'WRIGHT',
    'YELLOW MEDICINE',
  ],
  MO: [
    'ADAIR',
    'ANDREW',
    'ATCHISON',
    'AUDRAIN',
    'BARRY',
    'BARTON',
    'BATES',
    'BENTON',
    'BOLLINGER',
    'BOONE',
    'BUCHANAN',
    'BUTLER',
    'CALDWELL',
    'CALLAWAY',
    'CAMDEN',
    'CAPE GIRARDEAU',
    'CARROLL',
    'CARTER',
    'CASS',
    'CEDAR',
    'CHARITON',
    'CHRISTIAN',
    'CLARK',
    'CLAY',
    'CLINTON',
    'COLE',
    'COOPER',
    'CRAWFORD',
    'DADE',
    'DALLAS',
    'DAVIESS',
    'DEKALB',
    'DENT',
    'DOUGLAS',
    'DUNKLIN',
    'FRANKLIN',
    'GASCONADE',
    'GENTRY',
    'GREENE',
    'GRUNDY',
    'HARRISON',
    'HENRY',
    'HICKORY',
    'HOLT',
    'HOWARD',
    'HOWELL',
    'IRON',
    'JACKSON',
    'JASPER',
    'JEFFERSON',
    'JOHNSON',
    'KNOX',
    'LACLEDE',
    'LAFAYETTE',
    'LAWRENCE',
    'LEWIS',
    'LINCOLN',
    'LINN',
    'LIVINGSTON',
    'MACON',
    'MADISON',
    'MARIES',
    'MARION',
    'MCDONALD',
    'MERCER',
    'MILLER',
    'MISSISSIPPI',
    'MONITEAU',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'NEW MADRID',
    'NEWTON',
    'NODAWAY',
    'OREGON',
    'OSAGE',
    'OZARK',
    'PEMISCOT',
    'PERRY',
    'PETTIS',
    'PHELPS',
    'PIKE',
    'PLATTE',
    'POLK',
    'PULASKI',
    'PUTNAM',
    'RALLS',
    'RANDOLPH',
    'RAY',
    'REYNOLDS',
    'RIPLEY',
    'SALINE',
    'SCHUYLER',
    'SCOTLAND',
    'SCOTT',
    'SHANNON',
    'SHELBY',
    'ST CHARLES',
    'ST. CLAIR',
    'STE. GENEVIEVE',
    'ST. FRANCOIS',
    'ST LOUIS',
    'ST LOUIS (CITY)',
    'STODDARD',
    'STONE',
    'SULLIVAN',
    'TANEY',
    'TEXAS',
    'VERNON',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WORTH',
    'WRIGHT',
  ],
  MP: ['NORTHERN ISLANDS', 'NORTHERN MARIANA ISLANDS', 'ROTA', 'SAIPAN', 'TINIAN'],
  MS: [
    'ADAMS',
    'ALCORN',
    'AMITE',
    'ATTALA',
    'BENTON',
    'BOLIVAR',
    'CALHOUN',
    'CARROLL',
    'CHICKASAW',
    'CHOCTAW',
    'CLAIBORNE',
    'CLARKE',
    'CLAY',
    'COAHOMA',
    'COPIAH',
    'COVINGTON',
    'DESOTO',
    'FORREST',
    'FRANKLIN',
    'GEORGE',
    'GREENE',
    'GRENADA',
    'HANCOCK',
    'HARRISON',
    'HINDS',
    'HOLMES',
    'HUMPHREYS',
    'ISSAQUENA',
    'ITAWAMBA',
    'JACKSON',
    'JASPER',
    'JEFFERSON',
    'JEFFERSON DAVIS',
    'JONES',
    'KEMPER',
    'LAFAYETTE',
    'LAMAR',
    'LAUDERDALE',
    'LAWRENCE',
    'LEAKE',
    'LEE',
    'LEFLORE',
    'LINCOLN',
    'LOWNDES',
    'MADISON',
    'MARION',
    'MARSHALL',
    'MONROE',
    'MONTGOMERY',
    'NESHOBA',
    'NEWTON',
    'NOXUBEE',
    'OKTIBBEHA',
    'PANOLA',
    'PEARL RIVER',
    'PERRY',
    'PIKE',
    'PONTOTOC',
    'PRENTISS',
    'QUITMAN',
    'RANKIN',
    'SCOTT',
    'SHARKEY',
    'SIMPSON',
    'SMITH',
    'STONE',
    'SUNFLOWER',
    'TALLAHATCHIE',
    'TATE',
    'TIPPAH',
    'TISHOMINGO',
    'TUNICA',
    'UNION',
    'WALTHALL',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WILKINSON',
    'WINSTON',
    'YALOBUSHA',
    'YAZOO',
  ],
  MT: [
    'BEAVERHEAD',
    'BIG HORN',
    'BLAINE',
    'BROADWATER',
    'CARBON',
    'CARTER',
    'CASCADE',
    'CHOUTEAU',
    'CUSTER',
    'DANIELS',
    'DAWSON',
    'DEER LODGE',
    'FALLON',
    'FERGUS',
    'FLATHEAD',
    'GALLATIN',
    'GARFIELD',
    'GLACIER',
    'GOLDEN VALLEY',
    'GRANITE',
    'HILL',
    'JEFFERSON',
    'JUDITH BASIN',
    'LAKE',
    'LEWIS AND CLARK',
    'LIBERTY',
    'LINCOLN',
    'MADISON',
    'MCCONE',
    'MEAGHER',
    'MINERAL',
    'MISSOULA',
    'MUSSELSHELL',
    'PARK',
    'PETROLEUM',
    'PHILLIPS',
    'PONDERA',
    'POWDER RIVER',
    'POWELL',
    'PRAIRIE',
    'RAVALLI',
    'RICHLAND',
    'ROOSEVELT',
    'ROSEBUD',
    'SANDERS',
    'SHERIDAN',
    'SILVER BOW',
    'STILLWATER',
    'SWEET GRASS',
    'TETON',
    'TOOLE',
    'TREASURE',
    'VALLEY',
    'WHEATLAND',
    'WIBAUX',
    'YELLOWSTONE',
  ],
  NC: [
    'ALAMANCE',
    'ALEXANDER',
    'ALLEGHANY',
    'ANSON',
    'ASHE',
    'AVERY',
    'BEAUFORT',
    'BERTIE',
    'BLADEN',
    'BRUNSWICK',
    'BUNCOMBE',
    'BURKE',
    'CABARRUS',
    'CALDWELL',
    'CAMDEN',
    'CARTERET',
    'CASWELL',
    'CATAWBA',
    'CHATHAM',
    'CHEROKEE',
    'CHOWAN',
    'CLAY',
    'CLEVELAND',
    'COLUMBUS',
    'CRAVEN',
    'CUMBERLAND',
    'CURRITUCK',
    'DARE',
    'DAVIDSON',
    'DAVIE',
    'DUPLIN',
    'DURHAM',
    'EDGECOMBE',
    'FORSYTH',
    'FRANKLIN',
    'GASTON',
    'GATES',
    'GRAHAM',
    'GRANVILLE',
    'GREENE',
    'GUILFORD',
    'HALIFAX',
    'HARNETT',
    'HAYWOOD',
    'HENDERSON',
    'HERTFORD',
    'HOKE',
    'HYDE',
    'IREDELL',
    'JACKSON',
    'JOHNSTON',
    'JONES',
    'LEE',
    'LENOIR',
    'LINCOLN',
    'MACON',
    'MADISON',
    'MARTIN',
    'MCDOWELL',
    'MECKLENBURG',
    'MITCHELL',
    'MONTGOMERY',
    'MOORE',
    'NASH',
    'NEW HANOVER',
    'NORTHAMPTON',
    'ONSLOW',
    'ORANGE',
    'PAMLICO',
    'PASQUOTANK',
    'PENDER',
    'PERQUIMANS',
    'PERSON',
    'PITT',
    'POLK',
    'RANDOLPH',
    'RICHMOND',
    'ROBESON',
    'ROCKINGHAM',
    'ROWAN',
    'RUTHERFORD',
    'SAMPSON',
    'SCOTLAND',
    'STANLY',
    'STOKES',
    'SURRY',
    'SWAIN',
    'TRANSYLVANIA',
    'TYRRELL',
    'UNION',
    'VANCE',
    'WAKE',
    'WARREN',
    'WASHINGTON',
    'WATAUGA',
    'WAYNE',
    'WILKES',
    'WILSON',
    'YADKIN',
    'YANCEY',
  ],
  ND: [
    'ADAMS',
    'BARNES',
    'BENSON',
    'BILLINGS',
    'BOTTINEAU',
    'BOWMAN',
    'BURKE',
    'BURLEIGH',
    'CASS',
    'CAVALIER',
    'DICKEY',
    'DIVIDE',
    'DUNN',
    'EDDY',
    'EMMONS',
    'FOSTER',
    'GOLDEN VALLEY',
    'GRAND FORKS',
    'GRANT',
    'GRIGGS',
    'HETTINGER',
    'KIDDER',
    'LAMOURE',
    'LOGAN',
    'MCHENRY',
    'MCINTOSH',
    'MCKENZIE',
    'MCLEAN',
    'MERCER',
    'MORTON',
    'MOUNTRAIL',
    'NELSON',
    'OLIVER',
    'PEMBINA',
    'PIERCE',
    'RAMSEY',
    'RANSOM',
    'RENVILLE',
    'RICHLAND',
    'ROLETTE',
    'SARGENT',
    'SHERIDAN',
    'SIOUX',
    'SLOPE',
    'STARK',
    'STEELE',
    'STUTSMAN',
    'TOWNER',
    'TRAILL',
    'WALSH',
    'WARD',
    'WELLS',
    'WILLIAMS',
  ],
  NE: [
    'ADAMS',
    'ANTELOPE',
    'ARTHUR',
    'BANNER',
    'BLAINE',
    'BOONE',
    'BOX BUTTE',
    'BOYD',
    'BROWN',
    'BUFFALO',
    'BURT',
    'BUTLER',
    'CASS',
    'CEDAR',
    'CHASE',
    'CHERRY',
    'CHEYENNE',
    'CLAY',
    'COLFAX',
    'CUMING',
    'CUSTER',
    'DAKOTA',
    'DAWES',
    'DAWSON',
    'DEUEL',
    'DIXON',
    'DODGE',
    'DOUGLAS',
    'DUNDY',
    'FILLMORE',
    'FRANKLIN',
    'FRONTIER',
    'FURNAS',
    'GAGE',
    'GARDEN',
    'GARFIELD',
    'GOSPER',
    'GRANT',
    'GREELEY',
    'HALL',
    'HAMILTON',
    'HARLAN',
    'HAYES',
    'HITCHCOCK',
    'HOLT',
    'HOOKER',
    'HOWARD',
    'JEFFERSON',
    'JOHNSON',
    'KEARNEY',
    'KEITH',
    'KEYA PAHA',
    'KIMBALL',
    'KNOX',
    'LANCASTER',
    'LINCOLN',
    'LOGAN',
    'LOUP',
    'MADISON',
    'MCPHERSON',
    'MERRICK',
    'MORRILL',
    'NANCE',
    'NEMAHA',
    'NUCKOLLS',
    'OTOE',
    'PAWNEE',
    'PERKINS',
    'PHELPS',
    'PIERCE',
    'PLATTE',
    'POLK',
    'RED WILLOW',
    'RICHARDSON',
    'ROCK',
    'SALINE',
    'SARPY',
    'SAUNDERS',
    'SCOTTS BLUFF',
    'SEWARD',
    'SHERIDAN',
    'SHERMAN',
    'SIOUX',
    'STANTON',
    'THAYER',
    'THOMAS',
    'THURSTON',
    'VALLEY',
    'WASHINGTON',
    'WAYNE',
    'WEBSTER',
    'WHEELER',
    'YORK',
  ],
  NH: [
    'BELKNAP',
    'CARROLL',
    'CHESHIRE',
    'COOS',
    'GRAFTON',
    'HILLSBOROUGH',
    'MERRIMACK',
    'ROCKINGHAM',
    'STRAFFORD',
    'SULLIVAN',
  ],
  NJ: [
    'ATLANTIC',
    'BERGEN',
    'BURLINGTON',
    'CAMDEN',
    'CAPE MAY',
    'CUMBERLAND',
    'ESSEX',
    'GLOUCESTER',
    'HUDSON',
    'HUNTERDON',
    'MERCER',
    'MIDDLESEX',
    'MONMOUTH',
    'MORRIS',
    'OCEAN',
    'PASSAIC',
    'SALEM',
    'SOMERSET',
    'SUSSEX',
    'UNION',
    'WARREN',
  ],
  NM: [
    'BERNALILLO',
    'CATRON',
    'CHAVES',
    'CIBOLA',
    'COLFAX',
    'CURRY',
    'DE BACA',
    'DONA ANA',
    'EDDY',
    'GRANT',
    'GUADALUPE',
    'HARDING',
    'HIDALGO',
    'LEA',
    'LINCOLN',
    'LOS ALAMOS',
    'LUNA',
    'MCKINLEY',
    'MORA',
    'OTERO',
    'QUAY',
    'RIO ARRIBA',
    'ROOSEVELT',
    'SANDOVAL',
    'SAN JUAN',
    'SAN MIGUEL',
    'SANTA FE',
    'SIERRA',
    'SOCORRO',
    'TAOS',
    'TORRANCE',
    'UNION',
    'VALENCIA',
  ],
  NV: [
    'CARSON CITY (CITY)',
    'CHURCHILL',
    'CLARK',
    'DOUGLAS',
    'ELKO',
    'ESMERALDA',
    'EUREKA',
    'HUMBOLDT',
    'LANDER',
    'LINCOLN',
    'LYON',
    'MINERAL',
    'NYE',
    'PERSHING',
    'STOREY',
    'WASHOE',
    'WHITE PINE',
  ],
  NY: [
    'ALBANY',
    'ALLEGANY',
    'BRONX',
    'BROOME',
    'CATTARAUGUS',
    'CAYUGA',
    'CHAUTAUQUA',
    'CHEMUNG',
    'CHENANGO',
    'CLINTON',
    'COLUMBIA',
    'CORTLAND',
    'DELAWARE',
    'DUTCHESS',
    'ERIE',
    'ESSEX',
    'FRANKLIN',
    'FULTON',
    'GENESEE',
    'GREENE',
    'HAMILTON',
    'HERKIMER',
    'JEFFERSON',
    'KINGS',
    'LEWIS',
    'LIVINGSTON',
    'MADISON',
    'MONROE',
    'MONTGOMERY',
    'NASSAU',
    'NEW YORK',
    'NIAGARA',
    'ONEIDA',
    'ONONDAGA',
    'ONTARIO',
    'ORANGE',
    'ORLEANS',
    'OSWEGO',
    'OTSEGO',
    'PUTNAM',
    'QUEENS',
    'RENSSELAER',
    'RICHMOND',
    'ROCKLAND',
    'SARATOGA',
    'SCHENECTADY',
    'SCHOHARIE',
    'SCHUYLER',
    'SENECA',
    'STEUBEN',
    'ST. LAWRENCE',
    'SUFFOLK',
    'SULLIVAN',
    'TIOGA',
    'TOMPKINS',
    'ULSTER',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WESTCHESTER',
    'WYOMING',
    'YATES',
  ],
  OH: [
    'ADAMS',
    'ALLEN',
    'ASHLAND',
    'ASHTABULA',
    'ATHENS',
    'AUGLAIZE',
    'BELMONT',
    'BROWN',
    'BUTLER',
    'CARROLL',
    'CHAMPAIGN',
    'CLARK',
    'CLERMONT',
    'CLINTON',
    'COLUMBIANA',
    'COSHOCTON',
    'CRAWFORD',
    'CUYAHOGA',
    'DARKE',
    'DEFIANCE',
    'DELAWARE',
    'ERIE',
    'FAIRFIELD',
    'FAYETTE',
    'FRANKLIN',
    'FULTON',
    'GALLIA',
    'GEAUGA',
    'GREENE',
    'GUERNSEY',
    'HAMILTON',
    'HANCOCK',
    'HARDIN',
    'HARRISON',
    'HENRY',
    'HIGHLAND',
    'HOCKING',
    'HOLMES',
    'HURON',
    'JACKSON',
    'JEFFERSON',
    'KNOX',
    'LAKE',
    'LAWRENCE',
    'LICKING',
    'LOGAN',
    'LORAIN',
    'LUCAS',
    'MADISON',
    'MAHONING',
    'MARION',
    'MEDINA',
    'MEIGS',
    'MERCER',
    'MIAMI',
    'MONROE',
    'MONTGOMERY',
    'MORGAN',
    'MORROW',
    'MUSKINGUM',
    'NOBLE',
    'OTTAWA',
    'PAULDING',
    'PERRY',
    'PICKAWAY',
    'PIKE',
    'PORTAGE',
    'PREBLE',
    'PUTNAM',
    'RICHLAND',
    'ROSS',
    'SANDUSKY',
    'SCIOTO',
    'SENECA',
    'SHELBY',
    'STARK',
    'SUMMIT',
    'TRUMBULL',
    'TUSCARAWAS',
    'UNION',
    'VAN WERT',
    'VINTON',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WILLIAMS',
    'WOOD',
    'WYANDOT',
  ],
  OK: [
    'ADAIR',
    'ALFALFA',
    'ATOKA',
    'BEAVER',
    'BECKHAM',
    'BLAINE',
    'BRYAN',
    'CADDO',
    'CANADIAN',
    'CARTER',
    'CHEROKEE',
    'CHOCTAW',
    'CIMARRON',
    'CLEVELAND',
    'COAL',
    'COMANCHE',
    'COTTON',
    'CRAIG',
    'CREEK',
    'CUSTER',
    'DELAWARE',
    'DEWEY',
    'ELLIS',
    'GARFIELD',
    'GARVIN',
    'GRADY',
    'GRANT',
    'GREER',
    'HARMON',
    'HARPER',
    'HASKELL',
    'HUGHES',
    'JACKSON',
    'JEFFERSON',
    'JOHNSTON',
    'KAY',
    'KINGFISHER',
    'KIOWA',
    'LATIMER',
    'LE FLORE',
    'LINCOLN',
    'LOGAN',
    'LOVE',
    'MAJOR',
    'MARSHALL',
    'MAYES',
    'MCCLAIN',
    'MCCURTAIN',
    'MCINTOSH',
    'MURRAY',
    'MUSKOGEE',
    'NOBLE',
    'NOWATA',
    'OKFUSKEE',
    'OKLAHOMA',
    'OKMULGEE',
    'OSAGE',
    'OTTAWA',
    'PAWNEE',
    'PAYNE',
    'PITTSBURG',
    'PONTOTOC',
    'POTTAWATOMIE',
    'PUSHMATAHA',
    'ROGER MILLS',
    'ROGERS',
    'SEMINOLE',
    'SEQUOYAH',
    'STEPHENS',
    'TEXAS',
    'TILLMAN',
    'TULSA',
    'WAGONER',
    'WASHINGTON',
    'WASHITA',
    'WOODS',
    'WOODWARD',
  ],
  OR: [
    'BAKER',
    'BENTON',
    'CLACKAMAS',
    'CLATSOP',
    'COLUMBIA',
    'COOS',
    'CROOK',
    'CURRY',
    'DESCHUTES',
    'DOUGLAS',
    'GILLIAM',
    'GRANT',
    'HARNEY',
    'HOOD RIVER',
    'JACKSON',
    'JEFFERSON',
    'JOSEPHINE',
    'KLAMATH',
    'LAKE',
    'LANE',
    'LINCOLN',
    'LINN',
    'MALHEUR',
    'MARION',
    'MORROW',
    'MULTNOMAH',
    'POLK',
    'SHERMAN',
    'TILLAMOOK',
    'UMATILLA',
    'UNION',
    'WALLOWA',
    'WASCO',
    'WASHINGTON',
    'WHEELER',
    'YAMHILL',
  ],
  PA: [
    'ADAMS',
    'ALLEGHENY',
    'ARMSTRONG',
    'BEAVER',
    'BEDFORD',
    'BERKS',
    'BLAIR',
    'BRADFORD',
    'BUCKS',
    'BUTLER',
    'CAMBRIA',
    'CAMERON',
    'CARBON',
    'CENTRE',
    'CHESTER',
    'CLARION',
    'CLEARFIELD',
    'CLINTON',
    'COLUMBIA',
    'CRAWFORD',
    'CUMBERLAND',
    'DAUPHIN',
    'DELAWARE',
    'ELK',
    'ERIE',
    'FAYETTE',
    'FOREST',
    'FRANKLIN',
    'FULTON',
    'GREENE',
    'HUNTINGDON',
    'INDIANA',
    'JEFFERSON',
    'JUNIATA',
    'LACKAWANNA',
    'LANCASTER',
    'LAWRENCE',
    'LEBANON',
    'LEHIGH',
    'LUZERNE',
    'LYCOMING',
    'MCKEAN',
    'MERCER',
    'MIFFLIN',
    'MONROE',
    'MONTGOMERY',
    'MONTOUR',
    'NORTHAMPTON',
    'NORTHUMBERLAND',
    'PERRY',
    'PHILADELPHIA',
    'PIKE',
    'POTTER',
    'SCHUYLKILL',
    'SNYDER',
    'SOMERSET',
    'SULLIVAN',
    'SUSQUEHANNA',
    'TIOGA',
    'UNION',
    'VENANGO',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WESTMORELAND',
    'WYOMING',
    'YORK',
  ],
  PR: [
    'ADJUNTAS MUNICIPIO',
    'AGUADA MUNICIPIO',
    'AGUADILLA MUNICIPIO',
    'AGUAS BUENAS MUNICIPIO',
    'AIBONITO MUNICIPIO',
    'ANASCO MUNICIPIO',
    'ARECIBO MUNICIPIO',
    'ARROYO MUNICIPIO',
    'BARCELONETA MUNICIPIO',
    'BARRANQUITAS MUNICIPIO',
    'BAYAMON MUNICIPIO',
    'CABO ROJO MUNICIPIO',
    'CAGUAS MUNICIPIO',
    'CAMUY MUNICIPIO',
    'CANOVANAS MUNICIPIO',
    'CAROLINA MUNICIPIO',
    'CATANO MUNICIPIO',
    'CAYEY MUNICIPIO',
    'CEIBA MUNICIPIO',
    'CIALES MUNICIPIO',
    'CIDRA MUNICIPIO',
    'COAMO MUNICIPIO',
    'COMERIO MUNICIPIO',
    'COROZAL MUNICIPIO',
    'CULEBRA MUNICIPIO',
    'DORADO MUNICIPIO',
    'FAJARDO MUNICIPIO',
    'FLORIDA MUNICIPIO',
    'GUANICA MUNICIPIO',
    'GUAYAMA MUNICIPIO',
    'GUAYANILLA MUNICIPIO',
    'GUAYNABO MUNICIPIO',
    'GURABO MUNICIPIO',
    'HATILLO MUNICIPIO',
    'HORMIGUEROS MUNICIPIO',
    'HUMACAO MUNICIPIO',
    'ISABELA MUNICIPIO',
    'JAYUYA MUNICIPIO',
    'JUANA DIAZ MUNICIPIO',
    'JUNCOS MUNICIPIO',
    'LAJAS MUNICIPIO',
    'LARES MUNICIPIO',
    'LAS MARIAS MUNICIPIO',
    'LAS PIEDRAS MUNICIPIO',
    'LOIZA MUNICIPIO',
    'LUQUILLO MUNICIPIO',
    'MANATI MUNICIPIO',
    'MARICAO MUNICIPIO',
    'MAUNABO MUNICIPIO',
    'MAYAGUEZ MUNICIPIO',
    'MOCA MUNICIPIO',
    'MOROVIS MUNICIPIO',
    'NAGUABO MUNICIPIO',
    'NARANJITO MUNICIPIO',
    'OROCOVIS MUNICIPIO',
    'PATILLAS MUNICIPIO',
    'PENUELAS MUNICIPIO',
    'PONCE MUNICIPIO',
    'QUEBRADILLAS MUNICIPIO',
    'RINCON MUNICIPIO',
    'RIO GRANDE MUNICIPIO',
    'SABANA GRANDE MUNICIPIO',
    'SALINAS MUNICIPIO',
    'SAN GERMAN MUNICIPIO',
    'SAN JUAN MUNICIPIO',
    'SAN LORENZO MUNICIPIO',
    'SAN SEBASTIAN MUNICIPIO',
    'SANTA ISABEL MUNICIPIO',
    'TOA ALTA MUNICIPIO',
    'TOA BAJA MUNICIPIO',
    'TRUJILLO ALTO MUNICIPIO',
    'UTUADO MUNICIPIO',
    'VEGA ALTA MUNICIPIO',
    'VEGA BAJA MUNICIPIO',
    'VIEQUES MUNICIPIO',
    'VILLALBA MUNICIPIO',
    'YABUCOA MUNICIPIO',
    'YAUCO MUNICIPIO',
  ],
  RI: ['BRISTOL', 'KENT', 'NEWPORT', 'PROVIDENCE', 'WASHINGTON'],
  SC: [
    'ABBEVILLE',
    'AIKEN',
    'ALLENDALE',
    'ANDERSON',
    'BAMBERG',
    'BARNWELL',
    'BEAUFORT',
    'BERKELEY',
    'CALHOUN',
    'CHARLESTON',
    'CHEROKEE',
    'CHESTER',
    'CHESTERFIELD',
    'CLARENDON',
    'COLLETON',
    'DARLINGTON',
    'DILLON',
    'DORCHESTER',
    'EDGEFIELD',
    'FAIRFIELD',
    'FLORENCE',
    'GEORGETOWN',
    'GREENVILLE',
    'GREENWOOD',
    'HAMPTON',
    'HORRY',
    'JASPER',
    'KERSHAW',
    'LANCASTER',
    'LAURENS',
    'LEE',
    'LEXINGTON',
    'MARION',
    'MARLBORO',
    'MCCORMICK',
    'NEWBERRY',
    'OCONEE',
    'ORANGEBURG',
    'PICKENS',
    'RICHLAND',
    'SALUDA',
    'SPARTANBURG',
    'SUMTER',
    'UNION',
    'WILLIAMSBURG',
    'YORK',
  ],
  SD: [
    'AURORA',
    'BEADLE',
    'BENNETT',
    'BON HOMME',
    'BROOKINGS',
    'BROWN',
    'BRULE',
    'BUFFALO',
    'BUTTE',
    'CAMPBELL',
    'CHARLES MIX',
    'CLARK',
    'CLAY',
    'CODINGTON',
    'CORSON',
    'CUSTER',
    'DAVISON',
    'DAY',
    'DEUEL',
    'DEWEY',
    'DOUGLAS',
    'EDMUNDS',
    'FALL RIVER',
    'FAULK',
    'GRANT',
    'GREGORY',
    'HAAKON',
    'HAMLIN',
    'HAND',
    'HANSON',
    'HARDING',
    'HUGHES',
    'HUTCHINSON',
    'HYDE',
    'JACKSON',
    'JERAULD',
    'JONES',
    'KINGSBURY',
    'LAKE',
    'LAWRENCE',
    'LINCOLN',
    'LYMAN',
    'MARSHALL',
    'MCCOOK',
    'MCPHERSON',
    'MEADE',
    'MELLETTE',
    'MINER',
    'MINNEHAHA',
    'MOODY',
    'PENNINGTON',
    'PERKINS',
    'POTTER',
    'ROBERTS',
    'SANBORN',
    'SHANNON',
    'SPINK',
    'STANLEY',
    'SULLY',
    'TODD',
    'TRIPP',
    'TURNER',
    'UNION',
    'WALWORTH',
    'YANKTON',
    'ZIEBACH',
  ],
  TN: [
    'ANDERSON',
    'BEDFORD',
    'BENTON',
    'BLEDSOE',
    'BLOUNT',
    'BRADLEY',
    'CAMPBELL',
    'CANNON',
    'CARROLL',
    'CARTER',
    'CHEATHAM',
    'CHESTER',
    'CLAIBORNE',
    'CLAY',
    'COCKE',
    'COFFEE',
    'CROCKETT',
    'CUMBERLAND',
    'DAVIDSON',
    'DECATUR',
    'DEKALB',
    'DICKSON',
    'DYER',
    'FAYETTE',
    'FENTRESS',
    'FRANKLIN',
    'GIBSON',
    'GILES',
    'GRAINGER',
    'GREENE',
    'GRUNDY',
    'HAMBLEN',
    'HAMILTON',
    'HANCOCK',
    'HARDEMAN',
    'HARDIN',
    'HAWKINS',
    'HAYWOOD',
    'HENDERSON',
    'HENRY',
    'HICKMAN',
    'HOUSTON',
    'HUMPHREYS',
    'JACKSON',
    'JEFFERSON',
    'JOHNSON',
    'KNOX',
    'LAKE',
    'LAUDERDALE',
    'LAWRENCE',
    'LEWIS',
    'LINCOLN',
    'LOUDON',
    'MACON',
    'MADISON',
    'MARION',
    'MARSHALL',
    'MAURY',
    'MCMINN',
    'MCNAIRY',
    'MEIGS',
    'MONROE',
    'MONTGOMERY',
    'MOORE',
    'MORGAN',
    'OBION',
    'OVERTON',
    'PERRY',
    'PICKETT',
    'POLK',
    'PUTNAM',
    'RHEA',
    'ROANE',
    'ROBERTSON',
    'RUTHERFORD',
    'SCOTT',
    'SEQUATCHIE',
    'SEVIER',
    'SHELBY',
    'SMITH',
    'STEWART',
    'SULLIVAN',
    'SUMNER',
    'TIPTON',
    'TROUSDALE',
    'UNICOI',
    'UNION',
    'VAN BUREN',
    'WARREN',
    'WASHINGTON',
    'WAYNE',
    'WEAKLEY',
    'WHITE',
    'WILLIAMSON',
    'WILSON',
  ],
  TX: [
    'ANDERSON',
    'ANDREWS',
    'ANGELINA',
    'ARANSAS',
    'ARCHER',
    'ARMSTRONG',
    'ATASCOSA',
    'AUSTIN',
    'BAILEY',
    'BANDERA',
    'BASTROP',
    'BAYLOR',
    'BEE',
    'BELL',
    'BEXAR',
    'BLANCO',
    'BORDEN',
    'BOSQUE',
    'BOWIE',
    'BRAZORIA',
    'BRAZOS',
    'BREWSTER',
    'BRISCOE',
    'BROOKS',
    'BROWN',
    'BURLESON',
    'BURNET',
    'CALDWELL',
    'CALHOUN',
    'CALLAHAN',
    'CAMERON',
    'CAMP',
    'CARSON',
    'CASS',
    'CASTRO',
    'CHAMBERS',
    'CHEROKEE',
    'CHILDRESS',
    'CLAY',
    'COCHRAN',
    'COKE',
    'COLEMAN',
    'COLLIN',
    'COLLINGSWORTH',
    'COLORADO',
    'COMAL',
    'COMANCHE',
    'CONCHO',
    'COOKE',
    'CORYELL',
    'COTTLE',
    'CRANE',
    'CROCKETT',
    'CROSBY',
    'CULBERSON',
    'DALLAM',
    'DALLAS',
    'DAWSON',
    'DEAF SMITH',
    'DELTA',
    'DENTON',
    'DEWITT',
    'DICKENS',
    'DIMMIT',
    'DONLEY',
    'DUVAL',
    'EASTLAND',
    'ECTOR',
    'EDWARDS',
    'ELLIS',
    'EL PASO',
    'ERATH',
    'FALLS',
    'FANNIN',
    'FAYETTE',
    'FISHER',
    'FLOYD',
    'FOARD',
    'FORT BEND',
    'FRANKLIN',
    'FREESTONE',
    'FRIO',
    'GAINES',
    'GALVESTON',
    'GARZA',
    'GILLESPIE',
    'GLASSCOCK',
    'GOLIAD',
    'GONZALES',
    'GRAY',
    'GRAYSON',
    'GREGG',
    'GRIMES',
    'GUADALUPE',
    'HALE',
    'HALL',
    'HAMILTON',
    'HANSFORD',
    'HARDEMAN',
    'HARDIN',
    'HARRIS',
    'HARRISON',
    'HARTLEY',
    'HASKELL',
    'HAYS',
    'HEMPHILL',
    'HENDERSON',
    'HIDALGO',
    'HILL',
    'HOCKLEY',
    'HOOD',
    'HOPKINS',
    'HOUSTON',
    'HOWARD',
    'HUDSPETH',
    'HUNT',
    'HUTCHINSON',
    'IRION',
    'JACK',
    'JACKSON',
    'JASPER',
    'JEFF DAVIS',
    'JEFFERSON',
    'JIM HOGG',
    'JIM WELLS',
    'JOHNSON',
    'JONES',
    'KARNES',
    'KAUFMAN',
    'KENDALL',
    'KENEDY',
    'KENT',
    'KERR',
    'KIMBLE',
    'KING',
    'KINNEY',
    'KLEBERG',
    'KNOX',
    'LAMAR',
    'LAMB',
    'LAMPASAS',
    'LA SALLE',
    'LAVACA',
    'LEE',
    'LEON',
    'LIBERTY',
    'LIMESTONE',
    'LIPSCOMB',
    'LIVE OAK',
    'LLANO',
    'LOVING',
    'LUBBOCK',
    'LYNN',
    'MADISON',
    'MARION',
    'MARTIN',
    'MASON',
    'MATAGORDA',
    'MAVERICK',
    'MCCULLOCH',
    'MCLENNAN',
    'MCMULLEN',
    'MEDINA',
    'MENARD',
    'MIDLAND',
    'MILAM',
    'MILLS',
    'MITCHELL',
    'MONTAGUE',
    'MONTGOMERY',
    'MOORE',
    'MORRIS',
    'MOTLEY',
    'NACOGDOCHES',
    'NAVARRO',
    'NEWTON',
    'NOLAN',
    'NUECES',
    'OCHILTREE',
    'OLDHAM',
    'ORANGE',
    'PALO PINTO',
    'PANOLA',
    'PARKER',
    'PARMER',
    'PECOS',
    'POLK',
    'POTTER',
    'PRESIDIO',
    'RAINS',
    'RANDALL',
    'REAGAN',
    'REAL',
    'RED RIVER',
    'REEVES',
    'REFUGIO',
    'ROBERTS',
    'ROBERTSON',
    'ROCKWALL',
    'RUNNELS',
    'RUSK',
    'SABINE',
    'SAN AUGUSTINE',
    'SAN JACINTO',
    'SAN PATRICIO',
    'SAN SABA',
    'SCHLEICHER',
    'SCURRY',
    'SHACKELFORD',
    'SHELBY',
    'SHERMAN',
    'SMITH',
    'SOMERVELL',
    'STARR',
    'STEPHENS',
    'STERLING',
    'STONEWALL',
    'SUTTON',
    'SWISHER',
    'TARRANT',
    'TAYLOR',
    'TERRELL',
    'TERRY',
    'THROCKMORTON',
    'TITUS',
    'TOM GREEN',
    'TRAVIS',
    'TRINITY',
    'TYLER',
    'UPSHUR',
    'UPTON',
    'UVALDE',
    'VAL VERDE',
    'VAN ZANDT',
    'VICTORIA',
    'WALKER',
    'WALLER',
    'WARD',
    'WASHINGTON',
    'WEBB',
    'WHARTON',
    'WHEELER',
    'WICHITA',
    'WILBARGER',
    'WILLACY',
    'WILLIAMSON',
    'WILSON',
    'WINKLER',
    'WISE',
    'WOOD',
    'YOAKUM',
    'YOUNG',
    'ZAPATA',
    'ZAVALA',
  ],
  UT: [
    'BEAVER',
    'BOX ELDER',
    'CACHE',
    'CARBON',
    'DAGGETT',
    'DAVIS',
    'DUCHESNE',
    'EMERY',
    'GARFIELD',
    'GRAND',
    'IRON',
    'JUAB',
    'KANE',
    'MILLARD',
    'MORGAN',
    'PIUTE',
    'RICH',
    'SALT LAKE',
    'SAN JUAN',
    'SANPETE',
    'SEVIER',
    'SUMMIT',
    'TOOELE',
    'UINTAH',
    'UTAH',
    'WASATCH',
    'WASHINGTON',
    'WAYNE',
    'WEBER',
  ],
  VA: [
    'ACCOMACK',
    'ALBEMARLE',
    'ALEXANDRIA (CITY)',
    'ALLEGHANY',
    'AMELIA',
    'AMHERST',
    'APPOMATTOX',
    'ARLINGTON',
    'AUGUSTA',
    'BATH',
    'BEDFORD',
    'BEDFORD (CITY)',
    'BLAND',
    'BOTETOURT',
    'BRISTOL (CITY)',
    'BRUNSWICK',
    'BUCHANAN',
    'BUCKINGHAM',
    'BUENA VISTA (CITY)',
    'CAMPBELL',
    'CAROLINE',
    'CARROLL',
    'CHARLES CITY',
    'CHARLOTTE',
    'CHARLOTTESVILLE (CITY)',
    'CHESAPEAKE (CITY)',
    'CHESTERFIELD',
    'CLARKE',
    'COLONIAL HEIGHTS (CITY)',
    'COVINGTON (CITY)',
    'CRAIG',
    'CULPEPER',
    'CUMBERLAND',
    'DANVILLE (CITY)',
    'DICKENSON',
    'DINWIDDIE',
    'EMPORIA (CITY)',
    'ESSEX',
    'FAIRFAX',
    'FAIRFAX (CITY)',
    'FALLS CHURCH (CITY)',
    'FAUQUIER',
    'FLOYD',
    'FLUVANNA',
    'FRANKLIN',
    'FRANKLIN (CITY)',
    'FREDERICK',
    'FREDERICKSBURG (CITY)',
    'GALAX (CITY)',
    'GILES',
    'GLOUCESTER',
    'GOOCHLAND',
    'GRAYSON',
    'GREENE',
    'GREENSVILLE',
    'HALIFAX',
    'HAMPTON (CITY)',
    'HANOVER',
    'HARRISONBURG (CITY)',
    'HENRICO',
    'HENRY',
    'HIGHLAND',
    'HOPEWELL (CITY)',
    'ISLE OF WIGHT',
    'JAMES CITY',
    'KING AND QUEEN',
    'KING GEORGE',
    'KING WILLIAM',
    'LANCASTER',
    'LEE',
    'LEXINGTON (CITY)',
    'LOUDOUN',
    'LOUISA',
    'LUNENBURG',
    'LYNCHBURG (CITY)',
    'MADISON',
    'MANASSAS (CITY)',
    'MANASSAS PARK (CITY)',
    'MARTINSVILLE (CITY)',
    'MATHEWS',
    'MECKLENBURG',
    'MIDDLESEX',
    'MONTGOMERY',
    'NELSON',
    'NEW KENT',
    'NEWPORT NEWS (CITY)',
    'NORFOLK (CITY)',
    'NORTHAMPTON',
    'NORTHUMBERLAND',
    'NORTON (CITY)',
    'NOTTOWAY',
    'ORANGE',
    'PAGE',
    'PATRICK',
    'PETERSBURG (CITY)',
    'PITTSYLVANIA',
    'POQUOSON (CITY)',
    'PORTSMOUTH (CITY)',
    'POWHATAN',
    'PRINCE EDWARD',
    'PRINCE GEORGE',
    'PRINCE WILLIAM',
    'PULASKI',
    'RADFORD (CITY)',
    'RAPPAHANNOCK',
    'RICHMOND',
    'RICHMOND (CITY)',
    'ROANOKE',
    'ROANOKE (CITY)',
    'ROCKBRIDGE',
    'ROCKINGHAM',
    'RUSSELL',
    'SALEM (CITY)',
    'SCOTT',
    'SHENANDOAH',
    'SMYTH',
    'SOUTHAMPTON',
    'SPOTSYLVANIA',
    'STAFFORD',
    'STAUNTON (CITY)',
    'SUFFOLK (CITY)',
    'SURRY',
    'SUSSEX',
    'TAZEWELL',
    'VIRGINIA BEACH (CITY)',
    'WARREN',
    'WASHINGTON',
    'WAYNESBORO (CITY)',
    'WESTMORELAND',
    'WILLIAMSBURG (CITY)',
    'WINCHESTER (CITY)',
    'WISE',
    'WYTHE',
    'YORK',
  ],
  VI: ['ST. CROIX ISLAND', 'ST. JOHN ISLAND', 'ST. THOMAS ISLAND'],
  VT: [
    'ADDISON',
    'BENNINGTON',
    'CALEDONIA',
    'CHITTENDEN',
    'ESSEX',
    'FRANKLIN',
    'GRAND ISLE',
    'LAMOILLE',
    'ORANGE',
    'ORLEANS',
    'RUTLAND',
    'WASHINGTON',
    'WINDHAM',
    'WINDSOR',
  ],
  WA: [
    'ADAMS',
    'ASOTIN',
    'BENTON',
    'CHELAN',
    'CLALLAM',
    'CLARK',
    'COLUMBIA',
    'COWLITZ',
    'DOUGLAS',
    'FERRY',
    'FRANKLIN',
    'GARFIELD',
    'GRANT',
    'GRAYS HARBOR',
    'ISLAND',
    'JEFFERSON',
    'KING',
    'KITSAP',
    'KITTITAS',
    'KLICKITAT',
    'LEWIS',
    'LINCOLN',
    'MASON',
    'OKANOGAN',
    'PACIFIC',
    'PEND OREILLE',
    'PIERCE',
    'SAN JUAN',
    'SKAGIT',
    'SKAMANIA',
    'SNOHOMISH',
    'SPOKANE',
    'STEVENS',
    'THURSTON',
    'WAHKIAKUM',
    'WALLA WALLA',
    'WHATCOM',
    'WHITMAN',
    'YAKIMA',
  ],
  WI: [
    'ADAMS',
    'ASHLAND',
    'BARRON',
    'BAYFIELD',
    'BROWN',
    'BUFFALO',
    'BURNETT',
    'CALUMET',
    'CHIPPEWA',
    'CLARK',
    'COLUMBIA',
    'CRAWFORD',
    'DANE',
    'DODGE',
    'DOOR',
    'DOUGLAS',
    'DUNN',
    'EAU CLAIRE',
    'FLORENCE',
    'FOND DU LAC',
    'FOREST',
    'GRANT',
    'GREEN',
    'GREEN LAKE',
    'IOWA',
    'IRON',
    'JACKSON',
    'JEFFERSON',
    'JUNEAU',
    'KENOSHA',
    'KEWAUNEE',
    'LA CROSSE',
    'LAFAYETTE',
    'LANGLADE',
    'LINCOLN',
    'MANITOWOC',
    'MARATHON',
    'MARINETTE',
    'MARQUETTE',
    'MENOMINEE',
    'MILWAUKEE',
    'MONROE',
    'OCONTO',
    'ONEIDA',
    'OUTAGAMIE',
    'OZAUKEE',
    'PEPIN',
    'PIERCE',
    'POLK',
    'PORTAGE',
    'PRICE',
    'RACINE',
    'RICHLAND',
    'ROCK',
    'RUSK',
    'SAUK',
    'SAWYER',
    'SHAWANO',
    'SHEBOYGAN',
    'ST CROIX',
    'TAYLOR',
    'TREMPEALEAU',
    'VERNON',
    'VILAS',
    'WALWORTH',
    'WASHBURN',
    'WASHINGTON',
    'WAUKESHA',
    'WAUPACA',
    'WAUSHARA',
    'WINNEBAGO',
    'WOOD',
  ],
  WV: [
    'BARBOUR',
    'BERKELEY',
    'BOONE',
    'BRAXTON',
    'BROOKE',
    'CABELL',
    'CALHOUN',
    'CLAY',
    'DODDRIDGE',
    'FAYETTE',
    'GILMER',
    'GRANT',
    'GREENBRIER',
    'HAMPSHIRE',
    'HANCOCK',
    'HARDY',
    'HARRISON',
    'JACKSON',
    'JEFFERSON',
    'KANAWHA',
    'LEWIS',
    'LINCOLN',
    'LOGAN',
    'MARION',
    'MARSHALL',
    'MASON',
    'MCDOWELL',
    'MERCER',
    'MINERAL',
    'MINGO',
    'MONONGALIA',
    'MONROE',
    'MORGAN',
    'NICHOLAS',
    'OHIO',
    'PENDLETON',
    'PLEASANTS',
    'POCAHONTAS',
    'PRESTON',
    'PUTNAM',
    'RALEIGH',
    'RANDOLPH',
    'RITCHIE',
    'ROANE',
    'SUMMERS',
    'TAYLOR',
    'TUCKER',
    'TYLER',
    'UPSHUR',
    'WAYNE',
    'WEBSTER',
    'WETZEL',
    'WIRT',
    'WOOD',
    'WYOMING',
  ],
  WY: [
    'ALBANY',
    'BIG HORN',
    'CAMPBELL',
    'CARBON',
    'CONVERSE',
    'CROOK',
    'FREMONT',
    'GOSHEN',
    'HOT SPRINGS',
    'JOHNSON',
    'LARAMIE',
    'LINCOLN',
    'NATRONA',
    'NIOBRARA',
    'PARK',
    'PLATTE',
    'SHERIDAN',
    'SUBLETTE',
    'SWEETWATER',
    'TETON',
    'UINTA',
    'WASHAKIE',
    'WESTON',
  ],
};
